// functions copy-pasted, minimized and adapted from
// https://github.com/OfficeDev/office-js-helpers/blob/master/src/helpers/utilities.ts

export function isAddin(): boolean {
  return getHost() !== "WEB";
}

export function isIEOrEdge() {
  return /Edge\/|Trident\//gi.test(window.navigator.userAgent);
}


/*
* Retrieves host info using a workaround that utilizes the internals of the
* Office.js library. Such workarounds should be avoided, as they can lead to
* a break in behavior, if the internals are ever changed. In this case, however,
* Office.js will soon be delivering a new API to provide the host and platform
* information.
*/
function getHost(): "WEB" | "ACCESS" | "EXCEL" | "ONENOTE" | "OUTLOOK" | "POWERPOINT" | "PROJECT" | "WORD" {
  // A forthcoming API (partially rolled-out) will expose the host and platform info natively
  // when queried from within an add-in.
  // If the platform already exposes that info, then just return it
  // (but only after massaging it to fit the return types expected by this function)
  const Office = (window as any).Office as { context: IContext };
  const isHostExposedNatively = Office && Office.context && Office.context.host;

  if (isHostExposedNatively) {
    return <any> Office.context.host;
  } else {
    return <any> getHostFallback();
  }
}

function getHostFallback(): string {
  try {
    if (window.sessionStorage == null) {
      throw new Error(`Session Storage isn't supported`);
    }

    const hostInfoValue = window.sessionStorage.hostInfoValue as string;
    let host = getHostPart(hostInfoValue);
    host = host.toUpperCase() || "WEB";
    return host;
  } catch (error) {
    return "WEB";
  }
}

function getHostPart(hostInfoValue: string): string {
    if (hostInfoValue.includes("$")) {
      // assumed default!
      const [hostRaw, platformRaw, extras] = hostInfoValue.split("$");
      return hostRaw;
    } else if (hostInfoValue.includes("|")) {
      // used by older hosts... whatever they may be?
      const [hostRaw, platformRaw] = hostInfoValue.split("|");
      return hostRaw;
    }
}

interface IContext {
  host: string;
}
